import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

import { SpainFlag, UnitedStatesFlag } from "./flags";

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2, 2, 0)
  },
  field: {
    width: 280,
    maxWidth: "100%"
  },
  option: {
    display: "inline-flex",
    alignItems: "center"
  },
  flag: {
    width: 20,
    height: 14,
    marginRight: theme.spacing(1),
    borderRadius: 2,
    boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.2)"
  }
}));

const LANGUAGES = [
  { locale: "en", label: "English", Flag: UnitedStatesFlag },
  { locale: "es", label: "Spanish", Flag: SpainFlag }
];

// Rep-facing control for the language the merchant application opens in.
// The CRM itself stays English, so the labels are not translated.
const MerchantLanguageField = ({ value, onChange }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <TextField
        id="merchantUiLocale"
        label="Merchant Application Language"
        variant="outlined"
        className={classes.field}
        value={value}
        onChange={event => onChange(event.target.value)}
        select
      >
        {LANGUAGES.map(({ locale, label, Flag }) => (
          <MenuItem key={locale} value={locale}>
            <span className={classes.option}>
              <Flag className={classes.flag} />
              {label}
            </span>
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

export default MerchantLanguageField;
